export const STATUS_META = {
  pending_verification: { label: "Pending Verification", cls: "bg-amber-100 text-amber-800" },
  request_evidence:     { label: "Evidence Requested",   cls: "bg-orange-100 text-orange-800" },
  disputed:             { label: "Under Review",         cls: "bg-sky-100 text-sky-800" },
  approved:             { label: "Verified",             cls: "bg-emerald-100 text-emerald-800" },
  rejected:             { label: "Rejected",             cls: "bg-red-100 text-red-700" },
  reversed:             { label: "Reversed",             cls: "bg-stone-200 text-stone-700" },
  pending_legacy:       { label: "Legacy · Pending Review", cls: "bg-violet-100 text-violet-800" },
};

export const StatusBadge = ({ status, testId }) => {
  const m = STATUS_META[status] || { label: status, cls: "bg-stone-100 text-stone-700" };
  return (
    <span className={`inline-flex px-2 py-0.5 rounded-full text-[10px] font-black ${m.cls}`} data-testid={testId}>
      {m.label}
    </span>
  );
};

export const KIND_LABEL = {
  add_business: "Added a business", verify_business: "Verified a listing", fix_info: "Fixed wrong info",
  add_photo: "Added a photo", invite_friend: "Invited a friend", report_fake: "Reported a fake",
  help_elderly: "Helped an elderly user", digital_help: "Digital literacy help", blood_donation: "Blood donation",
  project_participation: "Project participation", project_joined: "Joined a project (legacy)",
};
